import { render, staticRenderFns } from "./TooltipsPopovers.vue?vue&type=template&id=7b4ea346"
import script from "./TooltipsPopovers.vue?vue&type=script&lang=js"
export * from "./TooltipsPopovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports